import { Component } from '@angular/core';

@Component({
    selector: 'app-config-title-bar',
    templateUrl: './config-title-bar.component.html',
    styleUrls: ['./config-title-bar.component.scss'],
    standalone: false
})
export class ConfigTitleBarComponent {}
